import { IoArrowBackOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

export const TermsOfUse = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-[#f5f5f5] min-h-screen pt-20 pb-20">
      <div className="flex justify-center">
        <div className="w-[98%]">
          <div className="flex items-center gap-4 mb-5">
            <button
              onClick={() => navigate(-1)}
              className="p-2 hover:bg-gray-200 rounded-full transition-colors"
            >
              <IoArrowBackOutline className="text-[24px] text-gray-700" />
            </button>
            <h1 className="text-[24px] font-semibold">
              Termos de Uso e Política de Privacidade
            </h1>
          </div>

          <div className="bg-white rounded-[18px] shadow-sm overflow-hidden">
            <iframe
              src="/Termo_uso_DV.pdf"
              title="Termos de Uso e Política de Privacidade"
              className="w-full border-0"
              style={{ height: "calc(100vh - 180px)" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
